var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:_vm.getClass,style:({fontSize:_vm.size,color: _vm.color}),on:{"click":_vm.click}})}
var staticRenderFns = []

export { render, staticRenderFns }